import { useEffect, useState } from 'react'
import { ouvirPerguntas, type Pergunta } from './confirmar'

// A janela que responde ao `confirmar(...)` (confirmar.ts). Montada UMA vez no
// App, fora das rotas: qualquer tela pode perguntar. Mesmo desenho das janelas
// de baixo da ficha (Compartilhar, Adicionar ao pedido) -- sobe do rodape,
// botoes grandes para o dedo.
export default function JanelaConfirmacao() {
  const [pergunta, setPergunta] = useState<Pergunta | null>(null)
  useEffect(() => ouvirPerguntas(setPergunta), [])
  if (pergunta === null) return null

  function responder(sim: boolean) {
    pergunta!.responder(sim)
    setPergunta(null)
  }

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-end" onClick={() => responder(false)}>
      <div
        role="alertdialog" aria-modal="true" aria-label="Confirmação"
        className="w-full bg-white rounded-t-2xl p-4 pb-6 space-y-4" onClick={(e) => e.stopPropagation()}
      >
        {/* Textos longos (importacao) vem com paragrafos separados por linha em branco. */}
        <div className="space-y-2">
          {pergunta.texto.split(/\n{2,}/).map((paragrafo, i) => (
            <p key={i} className={i === 0 ? 'text-base font-semibold text-slate-800' : 'text-sm text-slate-600'}>
              {paragrafo}
            </p>
          ))}
        </div>
        <div className="grid grid-cols-2 gap-3">
          <button type="button" onClick={() => responder(false)}
            className="rounded-lg border border-slate-300 py-3 font-semibold text-slate-700">
            Cancelar
          </button>
          <button type="button" autoFocus onClick={() => responder(true)}
            className={`rounded-lg py-3 font-semibold text-white ${pergunta.perigo ? 'bg-red-600' : 'bg-teal-700'}`}>
            {pergunta.botao}
          </button>
        </div>
      </div>
    </div>
  )
}
